import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
  Navigate,
} from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import PageHome from "./pages/PageHome";
import PageSpeakers from "./pages/PageSpeakers";
import PageSpeakers23 from "./pages/PageSpeakers23";
import PageSpeakers24 from "./pages/PageSpeakers24";
import PageSpeakers25 from "./pages/PageSpeakers25";
import PageAgenda from "./pages/PageAgenda";
import PageVenue from "./pages/PageVenue";
import PageExplore from "./pages/PageExplore";
import PageFAQ from "./pages/PageFAQ";
import PageRegistration from "./pages/PageRegistration";

import PageComingSoon from "./pages/PageComingSoon";

import PageSponsors from "./pages/PageSponsors";
import PageSponsorForm from "./pages/PageSponsorForm";

const App = () => {
  return (
    <Router>
      <ScrollToTop />
      <Header />
      <main>
        <Routes>
          {/* Legacy Redirects */}
          {/* <Route
            path="/form-register.html/*"
            element={<Navigate to="/Registration" replace />}
            caseSensitive={false}
          />
          <Route
            path="/form-sponsor.html/*"
            element={<Navigate to="/SponsorForm" replace />}
            caseSensitive={false}
          />
          <Route
            path="/registration.html/*"
            element={<Navigate to="/Registration" replace />}
            caseSensitive={false}
          />
          <Route
            path="/register.html/*"
            element={<Navigate to="/Registration" replace />}
            caseSensitive={false}
          />
          <Route
            path="/faq.html/*"
            element={<Navigate to="/FAQ" replace />}
            caseSensitive={false}
          />
          <Route
            path="/sponsors.html/*"
            element={<Navigate to="/Sponsors" replace />}
            caseSensitive={false}
          />
          <Route
            path="/agenda.html/*"
            element={<Navigate to="/Agenda" replace />}
            caseSensitive={false}
          /> */}

          {/* Main Navigation */}
          {/* <Route path="/" element={<PageHome />} /> */}
          <Route path="/Speakers" element={<PageSpeakers />} />
          {/* <Route path="/Speakers/2025" element={<PageSpeakers25 />} />
          <Route path="/Speakers/2024" element={<PageSpeakers24 />} />
          <Route path="/Speakers/2023" element={<PageSpeakers23 />} /> */}
          {/* <Route path="/Agenda" element={<PageAgenda />} />
          <Route path="/Venue" element={<PageVenue />} />
          <Route path="/Visit" element={<PageExplore />} /> */}
          <Route path="/Sponsors" element={<PageSponsors />} />
          {/* <Route path="/FAQ" element={<PageFAQ />} /> */}
          {/* <Route path="/Registration" element={<PageRegistration />} /> */}
          <Route path="/SponsorForm" element={<PageSponsorForm />} />

          {/* 404 Fallback */}
          {/* <Route path="*" element={<Navigate to="/" replace />} /> */}

          <Route path="/" element={<PageComingSoon />} />
        </Routes>
      </main>
      <Footer />
    </Router>
  );
};

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const timer = setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);

    return () => clearTimeout(timer);
  }, [pathname]);

  return null;
};

export default App;
